import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styles from "./phkl-page-container.module.css";
import { setItem, getItem } from "../../utils/local-storage";
import { ONBOARDING_PATH, ROOT_PATH } from "../../routes/constants";
import { getAccessibilityLabel, languageSelectionConfig } from "../../modules/onboarding/utils";
import prudentialIcon from "../icon/assets/prudential-logo.svg";
import pruforceIcon from "../icon/assets/pruforce-logo.svg";
import { ArrowBack } from "@mui/icons-material";
import { isMobile } from "../../utils/common-utils";

interface PageContainerProps {
  title: string;
  id?: string;
  children: React.ReactNode;
  showBackBtn?: boolean;
}

const PHKLPageContainer: React.FC<PageContainerProps> = ({ title, children, id, showBackBtn }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const _isMobile = isMobile();
  const [islanguagePopupOpen, setIslanguagePopupOpen] = useState(false);
  const handleLanguageChange = (lng: any) => {
    setIslanguagePopupOpen(false);
    setItem("i18nextLng", lng);
    i18n.changeLanguage(lng);
  };

  const toggleLanguagePopupOpen = () => {
    setIslanguagePopupOpen(!islanguagePopupOpen);
  };

  const handleDisclaimerClick = () => {
    navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/protocol`, {
      state: { title: t("Common.disclaimer"), des: t("Settings.disclaimer_content") },
    });
  };
  const handlePrivacyPolicyClick = () => {
    navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/protocol`, {
      state: { title: t("Common.privacy_notice"), des: t("Settings.privacy_policy_content") },
    });
  };
  const goBack = () => {
    navigate(-1);
  };

  const childrenEle = useMemo(() => {
    if (!children) return null;
    return <div className={styles.formContainer}>{children}</div>;
  }, [children]);

  const titleSection = () => {
    if (_isMobile) {
      if (title.length > 16) {
        return (
          <div className={styles.smallTitleSection}>
            {showBackBtn && (
              <ArrowBack
                style={{ cursor: "pointer", color: "white", fontSize: 30, paddingRight: 10 }}
                onClick={goBack}
              />
            )}
            <h1 className={styles.smallTitleText}>{title}</h1>
          </div>
        );
      }
    }

    return (
      <div className={styles.titleSection}>
        {showBackBtn && (
          <ArrowBack
            style={{ cursor: "pointer", color: "white", fontSize: 40, paddingRight: 10 }}
            onClick={goBack}
          />
        )}
        <h1 className={styles.titleText}>{title}</h1>
      </div>
    );
  };

  return (
    <div id={id} className={styles.mainContain}>
      <div className={styles.header}>
        <div className={styles.logoSection}>
          <img className={styles.logo} src={pruforceIcon} alt="" />
        </div>
        {titleSection()}
      </div>

      <div className={styles.mainContent}>{childrenEle}</div>

      <div className={styles.footer}>
        <img src={prudentialIcon} alt="Prudential Icon" className={styles.prudentialIcon} />
        <div className={styles.footerText}>
          <span className={styles.disclaimer} onClick={handleDisclaimerClick}>
            {t("Common.disclaimer")}
          </span>
          <span>{t("Common.and")}</span>
          <span className={styles.privacyPolicy} onClick={handlePrivacyPolicyClick}>
            {t("Common.privacy_policy")}
          </span>
        </div>
        {/* <div className={styles.version}>{t("Common.version")} 1.0</div> */}
      </div>

      <div className={styles.languageSection}>
        <span className={styles.language}>
          {getAccessibilityLabel(getItem("i18nextLng") as string)}
        </span>
        <div className={styles.languageIcon} onClick={toggleLanguagePopupOpen}></div>{" "}
      </div>
      {islanguagePopupOpen && (
        <div className={styles.languagePopup}>
          <ul>
            {languageSelectionConfig().availableLanguages.map((lang) => (
              <li
                key={lang.i18nLanguageCode}
                className={styles.languageItem}
                onClick={() => handleLanguageChange(lang.i18nLanguageCode)}
              >
                {lang.languageFullName}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PHKLPageContainer;
